export const getRouteWithBookingId = (route, id) =>
    route.replace(':bookingId', id)
